import React, {useState} from 'react'
import {Collapse} from 'react-collapse'
import './InfoBoxes.scss'

const Box = ({title, content}) => {
	const [active, setActive] = useState(false)

	return(
		<div className="Box">
			<div className="box-title">
				<button className={active ? 'active' : ''} onClick={() => setActive(!active)}>
					<p dangerouslySetInnerHTML={{__html: title}} />
					<span className="plus" />
				</button>
			</div>
			<Collapse isOpened={active} theme={{collapse: 'box-wrapper', content: 'box-content'}}>
				<div className="box-text" dangerouslySetInnerHTML={{__html: content}} />
			</Collapse>
		</div>
	)
}

export default ({boxes}) => {
	return(
		<div className="InfoBoxes grid">
			<div className="boxes">
				{
					boxes.map((box, i) => <Box key={i} {...box} /> )
				}
			</div>
		</div>
	)
}